import EmptyState from '../components/EmptyState'

function CrmSyncView() {
  return (
    <div className="content-panel">
      <EmptyState
        icon="🗂️"
        title="CRM Sync is coming soon"
        description="Hang tight—we're finishing up CRM sync. You'll be able to link accounts and contacts here."
        tags={['Coming soon', 'Stay tuned']}
      />
    </div>
  )
}

export default CrmSyncView
